export default __webpack_public_path__ + "media/images/logos/m_logo_dark-5f2c948b36f306090128c0a0d4b5916e.png";